import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box, CardActionArea } from '@mui/material';
import { useSelector } from 'react-redux';
import AppButton from '../../components/AppButton';
import { useNavigate } from 'react-router-dom';
import { Home } from '@mui/icons-material';
export default function NotFound() {
  const navigate = useNavigate();
  const data = useSelector(({ error }) => error);
  return (<Box height={'80%'} display={'flex'} justifyContent={'center'} alignItems={'center'} padding={2} >
    <Card sx={{ maxWidth: 400, background: 'transparent', boxShadow: 'none' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="auto"
          image="/images/static/blocked.png"
          alt="green iguana"
        />
        <CardContent>
          {data.error && <> <Typography gutterBottom fontSize={28} color={'#F8FAFF'} fontFamily={'Manrope'} textAlign={'center'}>
            {data.title}
          </Typography>
            <Typography variant="body2" fontSize={14} color={'#F8FAFF'} fontFamily={'Manrope'} textAlign={'center'}>
              {data.message}
            </Typography></>}
            {
              !data.error && <AppButton startIcon={<Home />} title={'Go To Home'} onClick={() => navigate('/home')}></AppButton>
            }
        </CardContent>
      </CardActionArea>
    </Card>
  </Box>
  );
}